howspace.widgets.onEvent('discussion:demo-content-creation:failed', (widget, notification) => {
    howspace.aiGen.clearPromptTimeout(widget);
    real.notification.show(notification.object.error, 'danger', true);
});
